import axios from 'axios';
import {UseFormReturn} from 'react-hook-form';
import {BackendErrorResponse} from './backend-error-response';
import {showHttpErrorToast} from '@common/utils/http/show-http-error-toast';

export function onFormQueryError(r: unknown, form: UseFormReturn<any>) {
  if (form && axios.isAxiosError(r)) {
    // Handle case where response exists
    if (r.response) {
      const response = r.response.data as BackendErrorResponse;
      const status = r.response.status;

      // Handle 413 (Request Entity Too Large) - file too large
      if (status === 413) {
        // Try to find a file field to set the error on
        const fileFields = ['template', 'thumbnail', 'file', 'image', 'document'];
        const targetField = fileFields.find(field => form.getValues(field));
        if (targetField) {
          form.setError(targetField, {
            message: response?.message || 'The file is too large to upload.',
          });
        } else {
          showHttpErrorToast(r);
        }
        return;
      }

      if (!response.errors) {
        showHttpErrorToast(r);
      } else {
        Object.entries(response.errors || {}).forEach(([key, errors], index) => {
          if (typeof errors === 'string') {
            form.setError(key, {message: errors}, {shouldFocus: index === 0});
          } else {
            errors.forEach((message, subIndex) => {
              form.setError(
                key,
                {message},
                {shouldFocus: index === 0 && subIndex === 0},
              );
            });
          }
        });
      }
    } else if (r.request) {
      // Request was made but no response received (network error, timeout, etc.)
      showHttpErrorToast(r);
    }
  } else {
    // Non-axios error
    showHttpErrorToast(r);
  }
}
